/**
 * Rich text editor for news articles
 * Wrapper around RichTextEditor with news-specific settings
 */
import { RichTextEditor } from './RichTextEditor'

interface NewsEditorProps {
  content: string
  onChange: (html: string) => void
}

export function NewsEditor({ content, onChange }: NewsEditorProps) {
  return <RichTextEditor content={content} onChange={onChange} minHeight="400px" />
}
